/**
 * Agp events
 * fichier construction structure webpack
 */

import $ from "jquery";
import 'jquery-ui';
import {gsap} from "gsap";
import 'bootstrap';
import {Tooltip, Toast, Popover} from 'bootstrap';

// Force jQuery global before loading bootstrap-table UMD plugins.
window.$ = $;
window.jQuery = $;
require("../AGP/PLUGS/bootstrap-table-master/dist/bootstrap-table.min.js");


// Fichiers plugins retouchés
import "../AGP/PLUGS/multiple-select/dist/multiple-select.js";
import "../AGP/PLUGS/multiple-select/dist/multiple-select-locale-all.js";


//import "../AGP/PLUGS/bootstrap-table-master/dist/bootstrap-table.min.js";
//import "../AGP/PLUGS/bootstrap-table-master/dist/locale/bootstrap-table-fr-FR.min.js";


// fonctions propres agp events
import Common from "./agp_common";
import Users from "./agp_users";
import Forms from "./agp_forms";
import Editor from "./agp_editor";
import Modules from "./agp_modules";
import Menu from "./agp_menu";
import Gestion from "./agp_gestion";
import Orgas from "./agp_orgas";
import Editions from "./agp_editions";
import Access from "./agp_access";
import Responsables from "./agp_responsables";
import Events from "./agp_events";




$(document).ready(function () {
    const common = new Common();
    const users = new Users();
    const forms = new Forms();
    const editor = new Editor();
    const module = new Modules();
    const menu = new Menu();
    const gestion = new Gestion();
    const orgas = new Orgas();
    const editions = new Editions();
    const access = new Access();
    const responsables = new Responsables();
    const events = new Events();
    common.getWINDOW();
    users.init();
    forms.init();
    editor.init();
    module.init();
    menu.init();
    gestion.init();
    orgas.init();
    editions.init();
    access.onReady();
    responsables.init();
    events.init();

});


